import { toLocaleString } from '@/utils/date/toLocaleString';
import differenceTime from '@/utils/date/differenceTime';
import { getMinMaxDataTime } from '@/utils/function';
import { timeAndTimeZone as timeWithTimeZone } from '@/utils/datetime';

const optionsShortDateOneDigit = {
	month: 'numeric', // 'numeric' for one-digit or two-digit month
	day: 'numeric', // 'numeric' for one-digit or two-digit day
	year: 'numeric'
};

const optionsShortDateTwoDigit = {
	month: '2-digit', // '2-digit' for two-digit month
	day: '2-digit', // '2-digit' for two-digit day
	year: 'numeric'
};

const optionsLongDate = {
	hour: '2-digit', // '2-digit' for two-digit hour
	minute: '2-digit', // '2-digit' for two-digit minute
	second: '2-digit' // '2-digit' for two-digit second
};

export default {
	methods: {
		toDateTimeString(value) {
			if (value && value > 0) {
				return getMinMaxDataTime(value);
			}

			return getMinMaxDataTime();
		},
		shortDateString(value) {
			if (value) {
				return toLocaleString(value, optionsShortDateOneDigit);
			}
			return '';
		},
		fullDateString(value, twoDigitMonth = false) {
			if (value) {
				const shortDateOptions = twoDigitMonth
					? optionsShortDateTwoDigit
					: optionsShortDateOneDigit;
				return toLocaleString(
					value,
					Object.assign({}, shortDateOptions, optionsLongDate)
				);
			}
			return '';
		},
		differenceDateString(value) {
			if (value) {
				return differenceTime(value);
			}
			return '';
		},
		timeAndTimeZone(value) {
			return timeWithTimeZone(value);
		}
	}
};
